import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getClientesId } from "../../redux/actions/actionClient";
import { getDocuments } from "../../redux/actions/actionDocument";
import { getInDocuments } from "../../redux/actions/actioninDocument";
import { useParams } from "react-router-dom";
import { format, addDays } from "date-fns";
import DatePicker from "react-datepicker";
import Swal from "sweetalert2";
import ClienteFaltantesPDF from "./clienteFaltantesPdf";

export default function ClienteDetail() {
  const dispatch = useDispatch();
  const clientes = useSelector((state) => state.clientes.clientesDetail);
  const documents = useSelector((state) => state.documents.allDocuments);
  const documentsIn = useSelector((state) => state.inDocuments.allInDocuments);
  const { id } = useParams();
  const [startDate] = useState(new Date());
  const [dateIn, setDateIn] = useState({
    desde: new Date(),
    hasta: new Date(),
  });
  const [documentsClient, setDocumentsClient] = useState();
  const [verPDF, setVerPDF] = useState(false);
  const [faltantes, setFaltantes] = useState();
  const [faltantesSinParcial, setFaltantesSinParcial] = useState();

  console.log(id);
  console.log(documents);
  console.log(documentsIn);
  

  useEffect(() => {
    dispatch(getDocuments());
    dispatch(getInDocuments());
    dispatch(getClientesId(id));
  }, [dispatch, id]);

  // const docNoSaldados = documents[0] !== undefined ? documents[0].filter(
  //   (e) => e.client_id._id === clientes._id && e.state === false
  // ) : null;

  // const docSaldados = documents[0] !== undefined ? documents[0].filter(
  //   (e) => e.client_id._id === clientes._id && e.state === true
  // ) : null;

  // const docParciales = documents[0] !== undefined ? documents[0].filter(
  //   (e) => e.client_id._id === clientes._id && e.parcial === true
  // ) : null;

  const handleDesde = (date) => {
    console.log(date);
    setDateIn({ ...dateIn, desde: date });
  };

  const handleHasta = (date) => {
    console.log(date);
    if (date > dateIn.desde) {
      console.log(dateIn.desde);
      setDateIn({ ...dateIn, hasta: date });
    } else {
      Swal.fire(`Fecha "Hasta" no puede ser anterior a fecha "Desde"`);
    }
  };

  const handleBuscar = () => {
    let auxDoc = documents[0].filter(
      (e) =>
        e.client_id._id === id &&
        new Date(e.dateSend) >= dateIn.desde &&
        new Date(e.dateSend) <= dateIn.hasta
    );
    //let auxDate = auxDoc.filter(e=> new Date(e.dateSend) >= dateIn.desde)
    console.log(auxDoc);
    //console.log(auxDate);
    if (auxDoc) {
      setDocumentsClient(auxDoc);
    } else {
      Swal.fire("El cliente no tiene remitos generados aún");
    }
  };

  const handleLimpiar = () => {
    setDocumentsClient();
  };
  //console.log(documentsClient);

  const handleFaltantesPDF = () => {
    
    let map = new Map();

  documentsIn[0]
    .filter((e) => 
      e.document_id && // 👈 clave
      e.client_id?.[0]?._id === id &&
      e.document_id.state === false 
    )
    .forEach((curr) => {
      const egresoId = curr.document_id._id;

      if (
        !map.has(egresoId) ||
        curr.numberDocument > map.get(egresoId).numberDocument
      ) {
        map.set(egresoId, curr);
      }
    });

  let faltantes = Array.from(map.values());

  console.log(faltantes);
  setFaltantes(faltantes);

  ///////////////////// Aca se mapean los faltantes sin parciales o sea que no hay documentos de entrada
    
    let faltantesNew =documents[0]
    .filter((e) => 
      e._id && // 👈 clave
      e.client_id?._id === id &&
      e.state === false &&
      e.parcial === false
    )
  
  
  setFaltantesSinParcial(faltantesNew);
    
  };
  console.log(faltantes);
  console.log(faltantesSinParcial);
  
  

  const opendPDF = () => {
        setVerPDF(true)
      } 

  return (
    <div className="w-screen max-h-full bg-gray-900">
      <div className="m-8 text-orange-500 text-[10pt] font-bold">
        <div className="pb-8">
          <p className="text-xl underline">Cliente - Detalle</p>
        </div>
        <div className="flex text-center">
          <div className="w-32 bg-slate-700 hover:text-white border-2 border-black">
                    <Link to={`/clientes/modificar/${id}`}>
                        <p>Modificar</p>                        
                    </Link>
          </div>
        </div>
        <div className="mt-6">
          <div className="flex">
            <p className="w-1/3">Cliente N°: {clientes.idClient}</p>
            <p className="w-1/3">CUIT: {clientes.cuit}</p>
          </div>
          <div className="flex w-3/3 py-4 border-b-2 border-slate-500">
            <p className="w-1/3">Nombre: {clientes.name}</p>
            <p className="w-1/3">Apellido: {clientes.lastName}</p>
            <p className="w-1/3">Empresa: {clientes.nameCompany}</p>
          </div>
          <div className="flex w-3/3 py-4 border-b-2 border-slate-500">
            <p className="w-1/3">Domicilio: {clientes.address}</p>
            <p className="w-1/3">Ciudad: {clientes.city}</p>
            <p className="w-1/3">Telefonos: {clientes.telephoneNumber}</p>
          </div>
          <div className="flex w-3/3 py-4 border-b-2 border-slate-500">
            <p className="w-1/3">Contacto: {clientes.contactName}</p>
            <p className="w-1/3">Email: {clientes.email}</p>
            <p className="w-1/3">Notas: {clientes.notes}</p>
          </div>
        </div>

        <div className="mt-8 text-[12pt]">
          <button className="w-52 bg-slate-700 hover:text-white  hover:bg-blue-700" onClick={handleFaltantesPDF}>
            Informe de Faltantes
          </button>
        </div>

        <div className="mt-8 text-white">
          Faltantes En Estado Parcial
        </div>
        <div className="flex mt-5">
          <p className="w-14 border ">Remito</p>
          <p className="w-[300px] border">Articulo</p>
          <p className="w-[500px] border">Descripcion</p>
          <p className="w-20 border text-center">Cantidad</p>
        </div>
        <div className="">
          {faltantes && faltantes.map((e) => {
            return (
              <div key={e._id} className="flex">
                <p className="w-14 border-x border-y border-slate-300">{e.document_id.numberDocument}</p>
                <div>
                {e.itemsMissing.map((i) => {
                  return (
                    <div className="flex border border-slate-300">
                      <p className="w-[300px]">{i.name}</p>
                      <p className="w-[500px]">{i.descrip}</p>
                      <p className="w-20 text-center">{i.quantity}</p>
                    </div>
                  )
                })}
                </div>                
              </div>
            );
          })}
        </div>

        <div className="mt-8 text-white">
          Faltantes En Estado Negativo
        </div>
        <div className="flex mt-5">
          <p className="w-14 border ">Remito</p>
          <p className="w-[300px] border">Articulo</p>
          <p className="w-[500px] border">Descripcion</p>
          <p className="w-20 border text-center">Cantidad</p>
        </div>
        <div className="">
          {faltantesSinParcial && faltantesSinParcial.map((e) => {
            return (
              <div key={e._id} className="flex">
                <p className="w-14 border-x border-y border-slate-300">{e.numberDocument}</p>
                <div>
                {e.quantityItems.map((i) => {
                  return (
                    <div className="flex border border-slate-300">
                      <p className="w-[300px]">{i.name}</p>
                      <p className="w-[500px]">{i.descrip}</p>
                      <p className="w-20 text-center">{i.quantity}</p>
                    </div>
                  )
                })}
                </div>                
              </div>
            );
          })}
        </div>

      <div>
        <button className="h-8 mt-5 w-32 rounded bg-sky-500 text-white" onClick={opendPDF}>Faltantes en PDF</button>
      </div>


        <div className="">
          <div>
            <div className="mt-8 text-[12pt]">Buscar Documentos</div>
            <div className="flex mt-4">
              <div className="flex">
                <label>Desde</label>
                <DatePicker
                  className="w-24 pl-3 ml-2 rounded bg-slate-700"
                  selected={startDate}
                  onChange={handleDesde}
                  value={
                    dateIn.desde ? format(dateIn.desde, "dd/MM/yyyy") : null
                  }
                />
              </div>
              <div className="flex ml-2">
                <label>Hasta</label>
                <DatePicker
                  className="w-24 pl-3 ml-2 rounded bg-slate-700"
                  selected={startDate}
                  onChange={handleHasta}
                  value={
                    dateIn.hasta ? format(dateIn.hasta, "dd/MM/yyyy") : null
                  }
                />
              </div>
              <div className="w-20 ml-2 text-center bg-slate-700 hover:text-white hover:bg-blue-700">
                <button className="" onClick={handleBuscar}>
                  Buscar
                </button>
              </div>
              <div className="w-20 ml-2 text-center bg-slate-700 hover:text-white hover:bg-blue-700">
                <button className="" onClick={handleLimpiar}>
                  Limpiar
                </button>
              </div>
            </div>
          </div>

          <div className="mt-4">
            <div className="flex">
              <p className="w-12">N° Doc</p>
              <p className="w-20 text-center">Envío</p>
              <p className="w-20 text-center">Recepción</p>
              <p className="w-20 text-center">Estado</p>
            </div>
            <div className="max-h-full overflow-y-auto">
              {documentsClient &&
                documentsClient.map((e) => {
                  return (
                    <div className=" " key={e._id}>
                      <Link to={`/documentos/${e._id}`}>
                        <div className="flex">
                          <div className="w-12">{e.numberDocument}</div>
                          <div className="w-20 text-center">
                            {format(new Date(e.dateSend), "dd/MM/yy")}
                          </div>
                          <div className="w-20 text-center">
                            {format(new Date(e.dateReception), "dd/MM/yy")}
                          </div>
                          <div className="w-20 text-center">
                            {e.parcial === true ? (
                              <p className="text-yellow-500">Parcial</p>
                            ) : e.state === true ? (
                              <p className="text-green-500">Saldado</p>
                            ) : (
                              <p className="text-red-600">No Saldado</p>
                            )}
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
      
      <div>
      {verPDF ? (
                  <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-0-sm
                    flex flex-col justify-center items-center">
                    <div className="bg-red-500 w-1/12 text-center rounded hover:bg-red-600">
                      <button className="text-black font-bold hover:text-white" onClick={()=> setVerPDF(false)}>Cerrar</button>
                    </div>             
                    <div>
                      <ClienteFaltantesPDF
                        key={id} 
                        id={id}
                        cliente={clientes}
                        faltantes={faltantes}
                        faltantesSinParcial={faltantesSinParcial}
                      />
                    </div>              
                  </div>
                ) : null}
      </div>
    </div>
  );
}
